import React from "react";
import { IVDMDashboardContent } from "redux/app/vdmdashboard/@types";

interface IFuel {
	fuelName: string;
	currentROB: number;
}

interface IFuelTableProps {
	fuelTableData: IVDMDashboardContent["bunkerRobs"];
}

const FuelTable: React.FC<IFuelTableProps> = (props) => {
	const { fuelTableData } = props;
	const fuels: IFuel[] = 
		fuelTableData?.map((fuel) => ({
			fuelName: fuel.label,
			currentROB: fuel.rob,
		})) ?? [];

	if (!fuels || fuels.length === 0) {
		return (
			<div className="bg-white rounded-md shadow-sm border border-gray-200 overflow-hidden mt-4">
				<div className="px-4 py-3 bg-gray-100 border-b border-gray-200 flex items-center justify-between">
					<h3 className="text-base font-medium text-gray-800">
						Fuel ROB Summary
					</h3>
				</div>
				<div className="px-4 py-8 text-center text-gray-500 text-sm">
					No data available
				</div>
			</div>
		);
	}

	return (
		<div className="overflow-x-auto mt-4 w-full">
			<table className="w-max min-w-full text-left text-sm border-collapse ws-scroll">
				<thead>
					<tr className="text-gray-700 bg-gray-100">
						<th className="px-4 py-2 font-medium border border-gray-300 whitespace-nowrap">
							Fuel
						</th>
						{fuels.map((fuel, index) => (
							<th
								key={index}
								className="px-4 py-2 font-medium border border-gray-300 whitespace-nowrap"
							>
								{fuel.fuelName}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					<tr className="hover:cursor-pointer">
						<td className="px-4 py-1.5 font-medium border border-gray-300 bg-white whitespace-nowrap">
							ROB (mt)
						</td>
						{fuels.map((fuel, index) => (
							<td
								key={index}
								className="px-4 py-1.5 border border-gray-300 bg-white whitespace-nowrap"
							>
								{fuel.currentROB}
							</td>
						))}
					</tr>
				</tbody>
			</table>
		</div>
	);
};

export default FuelTable;
